module.exports = __webpack_public_path__ + "static/background/login_bg@2x.png";